import { render, staticRenderFns } from "./MacroPopup.vue?vue&type=template&id=45aba497&scoped=true&"
import script from "./MacroPopup.vue?vue&type=script&lang=js&"
export * from "./MacroPopup.vue?vue&type=script&lang=js&"
import style0 from "./MacroPopup.vue?vue&type=style&index=0&id=45aba497&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aba497",
  null
  
)

export default component.exports